"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMonthlyActiveUserArgsSchema = exports.createDefaultMemberInsights = void 0;
var utils_1 = require("../../utils");
var suretype_1 = require("suretype");
var common_1 = require("../../common");
// ==========================
// utils
// ==========================
function createDefaultMemberInsights(user) {
    var _a, _b, _c, _d, _e;
    var _f;
    var now = new Date();
    var _g = (0, utils_1.getMonthNumber)(now), y = _g[0], m = _g[1];
    var w = (0, utils_1.getWeekNumber)(now)[1];
    return {
        details: {
            totalReward: 0,
            totalMembers: 1,
            members: (_a = {},
                _a[user.id] = (_f = user.name) !== null && _f !== void 0 ? _f : null,
                _a),
            weeklyReward: {},
            weeklyNewMembers: (_b = {},
                _b[y.toString()] = (_c = {},
                    _c[w.toString()] = 1,
                    _c),
                _b),
            monthlyActiveMembers: (_d = {},
                _d[y.toString()] = (_e = {},
                    _e[m.toString()] = 1,
                    _e),
                _d)
        }
    };
}
exports.createDefaultMemberInsights = createDefaultMemberInsights;
exports.addMonthlyActiveUserArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("addMonthlyActiveUser").required(),
    communityId: common_1.idSchema.required()
});
